import { Upload } from "lucide-react";
import { Button, Paper, TextInput, FileButton, FileInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";

import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAddUser, useUpdateUser } from "../../utils/mutations";
import { useUserById } from "../../utils/queries";
import useStore from "../../utils/store";

const AddUser = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const id = params.id;
  const page = searchParams.get("page") || "1";

  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      phoneNumber: "",
      dob: "",
      image: null,
    },
    validate: {
      name: (v) => (!v ? "Please enter name" : null),
      email: (v) => (!v ? "Please enter email" : null),
      phoneNumber: (v) => (!v ? "Please enter phone number" : null),
      dob: (v) => (!v ? "Please enter date of birth" : null),
    },
  });

  useEffect(() => {
    if (id && !user?.updateUser) {
      notifications.show({ message: "You don't have permission to edit users", color: "red" });
      navigate(`/users?page=${page}`);
    } else if (!id && !user?.addUser) {
      notifications.show({ message: "You don't have permission to add users", color: "red" });
      navigate(`/users?page=${page}`);
    }
  }, [id, user, navigate, page]);

  const { isPending, mutate } = useAddUser();
  const { isPending: isUpdating, mutate: update } = useUpdateUser({
    onSuccess: () => {
      navigate(`/users?page=${page}`);
    },
  });
  const { data, isLoading } = useUserById(params.id);
  useEffect(() => {
    if (data) {
      form.setValues({
        name: data?.name || "",
        email: data?.email || "",
        phoneNumber: data?.phoneNumber || "",
        dob: data?.dob ? data.dob.split("T")[0] : "",
      });
    }
  }, [data]);

  if (!user?.addUser && !user?.updateUser) {
    return null;
  }

  return (
    <>
      
      <Paper withBorder p="md"
        loading={isLoading}
        title={id ? "Edit User" : "Add User"}
        style={{
          maxWidth: "500px",
          width: "100%",
          marginInline: "auto",
        }}
      >
        <form
          onSubmit={form.onSubmit((values) => {
            const formData = new FormData();
            if (values.image) {
              formData.append("image", values.image);
            }
            formData.append("name", values.name);
            formData.append("email", values.email);
            formData.append("phoneNumber", values.phoneNumber);
            formData.append("dob", values.dob);

            if (id) {
              update({ id: id, data: values });
            } else {
              mutate(formData);
            }
          })}
        >
          <TextInput label="Name" placeholder="Enter name" {...form.getInputProps("name")} mb="sm" />
          <TextInput label="Email" placeholder="Enter email" {...form.getInputProps("email")} mb="sm" disabled={!!id} />
          <TextInput label="Phone Number" placeholder="Enter phone number" {...form.getInputProps("phoneNumber")} mb="sm" />
          <TextInput label="Date of Birth" type="date" {...form.getInputProps("dob")} mb="sm" />

          {!id && (
            <FileInput
              label="Image"
              placeholder="Click to Upload"
              leftSection={<Upload size={16} />}
              {...form.getInputProps("image")}
              mb="sm"
              accept="image/*"
            />
          )}
          <Button type="submit" loading={isPending || isUpdating}>
            Submit
          </Button>
        </form>
      </Paper>
    </>
  );
};

export default AddUser;
